import { forwardRef } from "react";

import { FontDecorators, ThemeDecorators } from "../themes";

interface PortalWrapperProps {
  children: React.ReactNode;
}

const PortalWrapper = forwardRef<HTMLDivElement, PortalWrapperProps>(
  (props: PortalWrapperProps, ref) => {
    const { children } = props;

    return (
      <FontDecorators ref={ref}>
        <ThemeDecorators>
          {children}
        </ThemeDecorators>
      </FontDecorators>
    );
  },
);
PortalWrapper.displayName = "PortalWrapper";

export { PortalWrapper };
